
import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";
import { getThemeColor, cssStripe } from "../palette";

@Component({
  filters: {},
})
export default class FileLinkPip extends Vue {
  @Prop({ type: String })
  public url: string;

  @Prop({ type: String, default: "view_list" })
  public icon: string;

  getThemeColor = getThemeColor;
  cssStripe = cssStripe;

  openLinkInTab(url: string) {
    window.open(url);
  }
}
